<script>
    export default {
        name: "ButtonWidthMixin",
        data () {
            return {
                buttonWidthValueToClass : {
                    "auto" : "auto-width",
                    "fullWidth" : "full-width"
                },
            }
        },
        mounted () {
            if (this.myData) {
                // Adding watcher on myData after myData is created.
                // If watcher is set on instantiation, it asks for myData before handleRegistration finishes.
                // At that point sectionId is not set yet, so sectionData returns an empty object.
                this.$watch('myData.responsiveButtonWidthClass', function (oldData, newData) {
                    if (typeof oldData === 'undefined' && typeof newData === 'undefined') {
                        return;
                    }
                    const responsiveButtonWidthClass = newData;
                    if (responsiveButtonWidthClass && responsiveButtonWidthClass[this.activeDevicePreview]) {
                        this.updateButtonWidthClass(responsiveButtonWidthClass[this.activeDevicePreview]);
                    }
                }, {deep: true});
            }
            // push responsive functions to nodeState
            this.responsiveFunctions.push('updateButtonWidthClassForDevice');
        },
        computed: {
            allWidthClasses () {
                return Object.keys(this.buttonWidthValueToClass).map(value => {
                    return this.buttonWidthValueToClass[value];
                },[]);
            },
        },
        methods: {
            getButtonWidth () {
                return this.getKeyForMatchingClass(this.buttonWidthValueToClass , {defaultValue :"auto"});
            },
            setButtonWidth (eventData) {
                let responsiveButtonWidthClass = this.myData.responsiveButtonWidthClass;
                if (!responsiveButtonWidthClass['desktop']) {
                    responsiveButtonWidthClass['desktop'] = this.buttonWidthValueToClass[this.getButtonWidth()];
                }
                responsiveButtonWidthClass[this.activeDevicePreview] = eventData.value ? "full-width" : "auto-width";
                this.changeMyData({responsiveButtonWidthClass});
            },
            updateButtonWidthClassForDevice (device, node) {
                const responsiveButtonWidthClass = this.myData.responsiveButtonWidthClass;

                if (responsiveButtonWidthClass) {
                    let newClass = false;
                    if (responsiveButtonWidthClass[device]) {
                        newClass = responsiveButtonWidthClass[device];
                    } else if (responsiveButtonWidthClass['desktop']) {
                        newClass = responsiveButtonWidthClass['desktop'];
                    }
                    if (newClass) {
                        this.updateButtonWidthClass(newClass, node);
                    }
                }
            },
            updateButtonWidthClass (newClass, node) {
                let params = {
                    newClass: newClass,
                    classesToRemove: this.allWidthClasses,
                }
                this.applyClass(params, node);
            }
        },
        watch: {
            activeDevicePreview: {
                handler () {
                    this.updateButtonWidthClassForDevice(this.activeDevicePreview);
                }
            }
        },
    }
</script>